import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import * as urlUtils from '@core/js/utils/url.util';
import { storageService } from '@core/js/services/storage.service';
import { useNavigate, useRemoveQueryParams } from '@core/js/hooks/navigate';
import { useIsAllowedToRedirect } from '@core/js/hooks/useIsAllowedToRedirect';

export const useRedirectToAfterLoginURL = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const removeQueryParams = useRemoveQueryParams();
    const isAllowedToRedirect = useIsAllowedToRedirect();

    return useCallback(() => {
        const { afterLoginUrl: afterLoginUrlParam, providers, categories } = urlUtils.getURLParams(location.search);
        const afterLoginUrlStored = storageService.session.getItem('afterLoginUrl');
        const afterLoginUrl = afterLoginUrlParam || afterLoginUrlStored;
        const urlSearchParams = afterLoginUrlParam || providers || categories; /* TotalCasino changes */

        if (!afterLoginUrl) {
            return;
        }

        urlSearchParams && removeQueryParams(['afterLoginUrl', 'providers', 'categories']); /* TotalCasino changes */
        storageService.session.removeItem('afterLoginUrl');

        if (isAllowedToRedirect(afterLoginUrl)) {
            navigate(afterLoginUrl, location.state);
        }
    }, [navigate, removeQueryParams, isAllowedToRedirect, location]);
};
